export default {
  /* Indexes */
  current_step_index () {
    return this.order_steps.indexOf(this.current_step_name)
  },

  previous_step_index () {
    return this.has_previous_step && this.current_step_index - 1
  },

  next_step_index () {
    return this.has_next_step && this.current_step_index + 1
  },

  /* Has step */
  /* !has_next_step means we are last step */
  has_next_step () {
    return this.current_step_index < this.order_steps.length - 1
  }, /* !has_previous_step means we are first step */

  has_previous_step () {
    return this.current_step_index > 0
  },

  /* Names */
  previous_step_name () {
    return this.has_previous_step && this.order_steps[this.previous_step_index]
  },
  next_step_name () {
    return this.has_next_step && this.order_steps[this.next_step_index]
  },

  /* Steps */
  current_step () {
    return this.steps[this.current_step_name]
  },

  next_step () {
    return this.has_next_step && this.steps[this.next_step_name]
  },

  isNextStepAccessible () {
    return this.has_next_step && this.isStepAvailable(this.current_step_name)
  },

  stepsValidator () {
    return this.order_steps
      .filter(stepName => stepName !== 'summary')
      .map(stepName => {
        return this.steps[stepName].visited ? this.isStepAvailable(stepName) : false
      })
  },

  indexLastStepAvailable () {
    const index = this.stepsValidator.indexOf(false)
    return index === -1 ? this.order_steps.length - 1 : index
  },

  currentValidator () {
    return this[this.current_step_name + 'Validator']
  },

  last_step_available () {
    return this.order_steps[this.indexLastStepAvailable]
  }
}
